goog.provide('el8.ptdata.model.med.fulfillment');
goog.require('el8.model.base');
goog.require('el8.data.referencedUsers');
goog.require('el8.ptdata.model.pharmacyPrescription');
goog.require('el8.service.tz');

(function() {
    var _class = function(spec) {
        if (spec.change_requested) {
          this.setChangeRequested(
            el8.ptdata.model.pharmacyPrescription(spec.change_requested)
          );
        }
        this.populate(spec);
        if (spec.change_modified) {
          this.setChangeModified(
            el8.ptdata.model.pharmacyPrescription(spec.change_modified)
          );
        }

        if (spec.pharmacy) {
            el8.data.pharmacies.create(spec.pharmacy);
        }
    };
    _class.inheritsFrom(el8_Entity);

    _class.addStringProperty("pharmacyNcpdpid");
    _class.addStringProperty("type");
    _class.addStringProperty("detail");
    _class.addStringProperty("state");
    _class.addDateTime("timeCompleted");

    _class.addBoolean("denied");
    _class.addBoolean("dismissed");
    _class.addBoolean("eRx");
    _class.addBoolean("error");
    _class.addBoolean("success");
    _class.addBoolean("pending");
    _class.addBoolean("sent");
    _class.addBoolean("retriable");
    _class.addBoolean("failedMissingDeaSchedule");
    _class.addIntProperty("serviceLocationId");

    _class.addIntProperty("cancelUserId");
    _class.addDateTime("cancelTime");
    _class.addStringProperty("cancelResponseReason");
    _class.addDateTime("cancelResponseTime");
    _class.addStringProperty("cancelNoteFromPharmacy");
    _class.addStringProperty("requestingUserReason", true);

    _class.addStringProperty("changeResponse");
    _class.addStringProperty("changeRequestType");
    _class.addIntProperty("changeResponseUserId");
    _class.addDateTime("changeResponseTime");
    _class.addStringProperty("changeResponseReason");
    _class.addStringProperty("changeResponseReasonCode");
    _class.addStringProperty("changeResponsePriorAuthNum");
    _class.addBoolean("linkedToChangeRequest");

    // el8.ptdata.model.pharmacyPrescription instances
    _class.addProperty("changeRequested");
    _class.addProperty("prescribedPrescription");
    _class.addProperty("changeModified");

    _class.prototype.showOnChartFeed = function() {
        var notPaper = this.getType() !== 'paper';
        // applicable here means if it's either not a change request or it is a
        // change request but it had an error. We also don't want to show change denials
        var showChangeIfApplicable = this.getType() !== 'surescripts_change';
        if (!showChangeIfApplicable) {
            showChangeIfApplicable = this.isError() || !(this.getChangeResponse() === 'denied' && this.isSuccess());
        }
        return notPaper && showChangeIfApplicable;
    };

    /**
     * Check if this fulfillment is a change response
     * @returns {bool}
     */
    _class.prototype.isChange = function() {
        return this.getType() === 'surescripts_change';
    }

    /**
     * Check if the fulfillment is a change response and it was a successful deny
     * @returns {bool}
     */
    _class.prototype.isChangeDenied = function() {
        return this.isChange() && this.getChangeResponse() === 'denied' && this.isSuccess();
    }

    _class.prototype.isCancel = function() {
        return (this.getType() === 'surescripts_cancel');
    };

    _class.prototype.isCanceled = function() {
        return (this.getType() === 'surescripts_cancel' && this.isSuccess());
    };

    _class.prototype.isCancelIgnored = function() {
      var cancelTime = this.getCancelTime()

      if (!cancelTime) {
        return false
      }

      var now = el8.service.tz.now();
      var hours = (now.getTime() - cancelTime.getTime()) / (1000 * 60 * 60);
      return hours > 24;
    };

    _class.prototype.getPharmacy = function() {
        if (this.getPharmacyNcpdpid()) {
            return el8.data.pharmacies.getByKey(this.getPharmacyNcpdpid());
        }
        return null;
    };

    _class.prototype.getCancelUserName = function() {
        var cancelUser = el8.data.referencedUsers.getById(this.getCancelUserId());
        return (cancelUser) ? cancelUser.getFullName() : '';
    };

    _class.prototype.getChangeResponseUserName = function() {
        var changeResponseUser = el8.data.referencedUsers.getById(this.getChangeResponseUserId());
        return (changeResponseUser) ? changeResponseUser.getFullName() : '';
    };

    _class.prototype.asSoyMap = function() {
        var mapped = this.parent.asSoyMap.call(this);
        var pharmacy = this.getPharmacy();
        if (pharmacy) {
            mapped['pharmacy'] = pharmacy.asSoyMap();
        }
        mapped['isCanceled'] = this.isCanceled();
        mapped['isCancelIgnored'] = this.isCancelIgnored();
        mapped['cancelUserName'] = this.getCancelUserName();
        mapped['changeResponseUserName'] = this.getChangeResponseUserName();
        return mapped;
    };

    el8.ptdata.model.med.fulfillment = function(spec) {
        return new _class(spec);
    };
})();
